import { selectExternalConfigs } from "../../redux/feature/settings/configurations-slice";
import { store } from "../../redux/store/store";

export const getVersionedApiUrl = (apiUrl: string): string => {
  let apiVersioning = selectExternalConfigs(store.getState()).apiVersion;
  if (apiUrl in apiVersioning) return `/${apiVersioning[apiUrl]}${apiUrl}`;
  return apiUrl;
};

export enum CPMVersions {
  CPM_VERSION32_0 = "5.3.32.0",
  CPM_VERSION36_0 = "5.3.36.0",
  CPM_VERSION38_0 = "5.3.38.0",
}

export const isCpmVersionLess = (target: CPMVersions): boolean => {
  // TODO build a custom selector for this case,
  //  so we can rely on the hook useAppSelector

  const cpmVersion = selectExternalConfigs(store.getState())?.cpmVersion;
  if (!cpmVersion) return true;
  const v1 = cpmVersion.split(".").map(Number);
  const v2 = target.split(".").map(Number);

  for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
    const num1 = v1[i] || 0;
    const num2 = v2[i] || 0;

    if (num1 < num2) return true;
    if (num1 > num2) return false;
  }
  return false; // Cambiato da true a false
};
